import React, {
    useState,
} from "react";

import {
    Link,
    useLocation,
    useNavigate,
} from "react-router-dom";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

const AlumniLogin = () => {

    const location =
        useLocation();

    const navigate =
        useNavigate();

    const [open, setOpen] =
        useState(false);

    const [message, setMessage] =
        useState("");

    const [error, setError] =
        useState("");

    const [loading, setLoading] =
        useState(false);

    const [
        username,
        setUsername,
    ] = useState("");

    const [
        password,
        setPassword,
    ] = useState("");

    const [
        alumni,
        setAlumni,
    ] = useState(null);

    const [comment, setComment] =
        useState("");

    const handleLogin =
        async (e) => {

            e.preventDefault();

            setLoading(true);

            setMessage("");
            setError("");

            try {

                const res =
                    await fetch(
                        "https://stjosephweb.ilakshyaerp.in/api/alumni/login",
                        {
                            method:
                                "POST",

                            headers: {
                                "Content-Type":
                                    "application/json",
                            },

                            body: JSON.stringify({
                                username,
                                password,
                            }),
                        }
                    );

                const result =
                    await res.json();

                if (
                    result.success
                ) {

                    setMessage(
                        "Login Successful ✅"
                    );

                    setAlumni(
                        result.alumni
                    );

                } else {

                    setError(
                        result.message
                    );

                }

            } catch {

                setError(
                    "Something went wrong"
                );

            } finally {

                setLoading(false);

            }
        };

    const submitComment =
        async () => {

            try {

                const res =
                    await fetch(
                        "https://stjosephweb.ilakshyaerp.in/api/alumni-comment/add",
                        {
                            method:
                                "POST",

                            headers: {
                                "Content-Type":
                                    "application/json",
                            },

                            body: JSON.stringify({

                                alumniId:
                                    alumni.id,

                                registrationNo:
                                    alumni.registrationNo,

                                commentText:
                                    comment,

                            }),
                        }
                    );

                const result =
                    await res.json();

                if (
                    result.success
                ) {

                    setMessage(
                        result.message
                    );

                    setComment("");

                } else {

                    setError(
                        result.message
                    );

                }

            } catch {

                setError(
                    "Comment failed ❌"
                );

            }
        };

    return (

        <>

            {/* HEADER */}
            <Header
                toggleSidebar={() =>
                    setOpen(true)
                }
            />

            {/* SIDEBAR */}
            <Sidebar
                isOpen={open}
                close={() =>
                    setOpen(false)
                }
            />

            {/* PAGE */}
            <div className="w-full bg-[#f5f5f5] min-h-screen">

                {/* MENU BAR */}
                <div className="sticky top-0 z-40 bg-[#d89f12] shadow-md">

                    <div className="max-w-7xl mx-auto px-4">

                        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-7 py-4 text-white text-sm md:text-base font-medium">

                            {/* REGISTRATION */}
                            <Link
                                to="/alumni"
                                className={`
                                whitespace-nowrap transition-all duration-300 border-r border-white pr-5

                                ${
                                    location.pathname ===
                                    "/alumni"
                                        ? "text-[#072F5F] font-bold"
                                        : "hover:text-[#072F5F]"
                                }
                              `}
                            >
                                Alumni Registration
                            </Link>

                            {/* LOGIN */}
                            <Link
                                to="/alumni-login"
                                className={`
                                whitespace-nowrap transition-all duration-300 border-r border-white pr-5

                                ${
                                    location.pathname ===
                                    "/alumni-login"
                                        ? "text-[#072F5F] font-bold"
                                        : "hover:text-[#072F5F]"
                                }
                              `}
                            >
                                Alumni Login
                            </Link>

                            {/* COMMENT */}
                            <Link
                                to="/alumni-comments"
                                className="
                                whitespace-nowrap transition-all duration-300 hover:text-[#072F5F]
                              "
                            >
                                Alumni Comment
                            </Link>

                        </div>

                    </div>

                </div>

                {/* MAIN */}
                <div className="max-w-5xl mx-auto px-4 md:px-10 py-14">

                    {/* LOGIN FORM */}
                    {!alumni ? (

                        <div className="bg-[#f8f6e8] rounded-[20px] shadow-md border border-[#e3dcc0] overflow-hidden">

                            {/* TOP */}
                            <div className="bg-[#072F5F] px-6 md:px-10 py-5">

                                <h2 className="text-3xl md:text-4xl font-bold text-white">

                                    Alumni Login

                                </h2>

                            </div>

                            {/* BODY */}
                            <div className="px-5 md:px-10 py-14">

                                {/* SUCCESS MESSAGE */}
                                {
                                    message && (

                                        <div
                                            className="
                                            bg-green-100
                                            border
                                            border-green-500
                                            text-green-700
                                            px-5
                                            py-4
                                            rounded-lg
                                            mb-6
                                          "
                                        >

                                            ✅ {message}

                                        </div>
                                    )
                                }

                                {/* ERROR MESSAGE */}
                                {
                                    error && (

                                        <div
                                            className="
                                            bg-red-100
                                            border
                                            border-red-500
                                            text-red-700
                                            px-5
                                            py-4
                                            rounded-lg
                                            mb-6
                                          "
                                        >

                                            ❌ {error}

                                        </div>
                                    )
                                }

                                <form
                                    onSubmit={
                                        handleLogin
                                    }
                                >

                                    <div className="max-w-xl mx-auto">

                                        {/* USERNAME */}
                                        <div className="mb-8 flex flex-col md:flex-row md:items-center gap-3">

                                            <label className="md:w-40 text-[16px] font-semibold text-[#5b5b5b]">

                                                UserName :-

                                            </label>

                                            <input
                                                type="text"
                                                value={
                                                    username
                                                }
                                                onChange={(e) =>
                                                    setUsername(
                                                        e.target.value
                                                    )
                                                }
                                                className="
                                                flex-1
                                                border
                                                border-gray-400
                                                h-11
                                                px-3
                                                bg-white
                                              "
                                                required
                                            />

                                        </div>

                                        {/* PASSWORD */}
                                        <div className="mb-10 flex flex-col md:flex-row md:items-center gap-3">

                                            <label className="md:w-40 text-[16px] font-semibold text-[#5b5b5b]">

                                                Password :-

                                            </label>

                                            <input
                                                type="password"
                                                value={
                                                    password
                                                }
                                                onChange={(e) =>
                                                    setPassword(
                                                        e.target.value
                                                    )
                                                }
                                                className="
                                                flex-1
                                                border
                                                border-gray-400
                                                h-11
                                                px-3
                                                bg-white
                                              "
                                                required
                                            />

                                        </div>

                                        {/* BUTTONS */}
                                        <div className="flex justify-center gap-5">

                                            {/* LOGIN */}
                                            <button
                                                type="submit"
                                                disabled={loading}
                                                className="
                                                bg-[#d89f12]
                                                hover:bg-[#072F5F]
                                                text-white
                                                px-8
                                                py-2
                                                transition-all
                                                duration-300
                                              "
                                            >

                                                {
                                                    loading
                                                        ? "Please Wait..."
                                                        : "Login"
                                                }

                                            </button>

                                            {/* CANCEL */}
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    navigate("/")
                                                }
                                                className="
                                                bg-gray-500
                                                hover:bg-red-600
                                                text-white
                                                px-8
                                                py-2
                                                transition-all
                                                duration-300
                                              "
                                            >
                                                Cancel
                                            </button>

                                        </div>

                                    </div>

                                </form>

                            </div>

                        </div>

                    ) : (

                        /* PROFILE SECTION */
                        <div className="bg-[#f8f6e8] rounded-[20px] shadow-md border border-[#e3dcc0] overflow-hidden">

                            {/* HEADER */}
                            <div className="bg-[#072F5F] px-6 md:px-10 py-8">

                                <div className="flex flex-col md:flex-row items-center gap-8">

                                    {/* IMAGE */}
                                    <img
                                        src={`https://stjosephweb.ilakshyaerp.in/uploads/alumni/${alumni.image}`}
                                        alt=""
                                        className="
                                        w-40
                                        h-40
                                        rounded-full
                                        object-cover
                                        border-4
                                        border-white
                                      "
                                    />

                                    {/* DETAILS */}
                                    <div className="text-white text-center md:text-left">

                                        <h2 className="text-4xl font-bold">

                                            {
                                                alumni.fullName
                                            }

                                        </h2>

                                        <p className="mt-3 text-lg">

                                            Registration No :
                                            {" "}
                                            {
                                                alumni.registrationNo
                                            }

                                        </p>

                                        <p className="mt-2 text-lg">

                                            Class :
                                            {" "}
                                            {
                                                alumni.className
                                            }

                                        </p>

                                    </div>

                                </div>

                            </div>

                            {/* BODY */}
                            <div className="p-6 md:p-10">

                                {/* STATUS */}
                                <div className="mb-10">

                                    <h3 className="text-2xl font-bold text-[#5b5b5b] mb-5">

                                        Approval Status

                                    </h3>

                                    <div
                                        className={`
                                        px-6
                                        py-4
                                        rounded-xl
                                        text-white
                                        font-bold
                                        text-center
                                        text-xl

                                        ${
                                            alumni.status ===
                                            "approved"
                                                ? "bg-green-600"
                                                : alumni.status ===
                                                    "rejected"
                                                    ? "bg-red-600"
                                                    : "bg-yellow-500"
                                        }
                                      `}
                                    >

                                        {
                                            alumni.status
                                        }

                                    </div>

                                </div>

                                {/* DETAILS */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                    <div className="bg-white border border-gray-200 rounded-xl p-6">

                                        <p className="text-gray-500 mb-2">

                                            Father Name

                                        </p>

                                        <h4 className="font-bold text-lg text-[#072F5F]">

                                            {
                                                alumni.fatherName
                                            }

                                        </h4>

                                    </div>

                                    <div className="bg-white border border-gray-200 rounded-xl p-6">

                                        <p className="text-gray-500 mb-2">

                                            Mother Name

                                        </p>

                                        <h4 className="font-bold text-lg text-[#072F5F]">

                                            {
                                                alumni.motherName
                                            }

                                        </h4>

                                    </div>

                                    <div className="bg-white border border-gray-200 rounded-xl p-6">

                                        <p className="text-gray-500 mb-2">

                                            Mobile Number

                                        </p>

                                        <h4 className="font-bold text-lg text-[#072F5F]">

                                            {
                                                alumni.mobileNo
                                            }

                                        </h4>

                                    </div>

                                    <div className="bg-white border border-gray-200 rounded-xl p-6">

                                        <p className="text-gray-500 mb-2">

                                            Email Address

                                        </p>

                                        <h4 className="font-bold text-lg text-[#072F5F]">

                                            {
                                                alumni.email
                                            }

                                        </h4>

                                    </div>

                                </div>

                                {/* COMMENT SECTION */}
                                {
                                    alumni &&
                                    alumni.status ===
                                    "approved" && (

                                        <div className="mt-10">

                                            <h2 className="text-2xl font-bold text-[#072F5F] mb-5">

                                                Add Comment

                                            </h2>

                                            <textarea
                                                rows="5"
                                                value={comment}
                                                onChange={(e) =>
                                                    setComment(
                                                        e.target.value
                                                    )
                                                }
                                                className="
                                                w-full
                                                border
                                                border-gray-300
                                                rounded-xl
                                                p-4
                                              "
                                                placeholder="Write your comment..."
                                            />

                                            <button
                                                onClick={
                                                    submitComment
                                                }
                                                className="
                                                mt-5
                                                bg-[#072F5F]
                                                hover:bg-[#d89f12]
                                                text-white
                                                px-8
                                                py-3
                                                rounded-xl
                                              "
                                            >
                                                Submit Comment
                                            </button>

                                        </div>
                                    )
                                }

                                {/* BUTTON */}
                                <div className="mt-10 text-center">

                                    <button
                                        onClick={() =>
                                            navigate("/")
                                        }
                                        className="
                                        bg-[#072F5F]
                                        hover:bg-[#d89f12]
                                        text-white
                                        px-8
                                        py-3
                                        transition-all
                                        duration-300
                                      "
                                    >
                                        Back To Home
                                    </button>

                                </div>

                            </div>

                        </div>
                    )}

                </div>

            </div>

            {/* FOOTER */}
            <Footer />

        </>
    );
};

export default AlumniLogin;